module.exports = __webpack_public_path__ + "img/login_banner_ele.e16d60b1.png";